import { resourcesLanguageFrench as raguResourcesLanguageFrench } from '@ragu-components/ord-providers';

import { adminResourcesLanguageFrench } from './adminResources';
import { assignedResourcesLanguageFrench } from './assignedResources';
import { calendarsLanguageFrench } from './calendars';
import { rolesLanguageFrench } from './roles';
import { serviceClassesLanguageFrench } from './serviceClasses';
import { servicesResourcesLanguageFrench } from './servicesResources';
import { systemResourcesLanguageFrench } from './systemResources';
import { userResourcesLanguageFrench } from './userResources/userResourcesLanguageFrench';

import type { ResourcesTranlationMessages } from './resourcesTranslationMessages';

export const resourcesLanguageFrench: ResourcesTranlationMessages = {
  resources: {
    ...raguResourcesLanguageFrench,
    ...calendarsLanguageFrench,
    ...adminResourcesLanguageFrench,
    ...userResourcesLanguageFrench,
    ...servicesResourcesLanguageFrench,
    ...serviceClassesLanguageFrench,
    ...assignedResourcesLanguageFrench,
    ...systemResourcesLanguageFrench,
    ...rolesLanguageFrench,
  },
};
